// Generated by `npm run nenue` (scripts/nenue.ts) from data/ncrmp-fish-maui-nui/, data/mrip-hawaii/ and data/ncei-0303929/.
// Do not edit by hand: change the script and run it. tests/nenue.test.ts builds it again and fails if this file is not
// what the archives give.

/**
 * The nenue's measured figures (M178, `scripts/nenue.ts` says how): NOAA's divers' chubs at Maui Nui, 2013 to 2024
 * (535 fish in 520 site visits, 12 strata), the fork lengths of the 176 chubs Hawaiʻi's fishers kept that MRIP's
 * interviewers measured, 2003 to 2025, and the main islands' catch a year, 2023 to 2025; and Oʻahu's chubs, 2020 to 2023
 * (Weng 2025: 434 measured for both lengths, 443 weighed, 143 females' maturity). MEASURED by the script.
 */
export const NENUE_SURVEY = {
  /** Total length mm = a + b fork length mm (Oʻahu's chubs). */
  tlInterceptMm: 11.6012,
  tlSlope: 1.10253,
  /** Weight g = a fork length cm ^ b (Oʻahu's chubs). */
  weightA: 0.0199576,
  weightB: 3.05736,
  /** The females half mature at a fork length mm, and the logistic's slope a mm (Oʻahu's chubs). */
  femaleHalfMatureForkMm: 327.806,
  femaleMaturityPerMm: 0.0249854,
  /** Chubs a hectare of Maui Nui's reef, and their kg, the strata weighted by their floor. */
  perHa: 39.16,
  kgPerHa: 10.139,
  /** The fishery's half taken and most taken, fork length mm. */
  takenHalfForkMm: 212.5,
  takenMostForkMm: 262.5,
  /** The chubs of the sizes taken, kg a hectare, each weighed by its share taken. */
  takenKgPerHa: 6.699,
  /** Its error over itself in one survey round, the rounds' mean (2013, 2015, 2016, 2019, 2024); the rounds pooled's, a check. */
  takenCv: 0.5385,
  pooledCv: 0.2998,
  /** The divers' chubs of the most-taken size and more, their mean fork length mm. */
  takenMeanForkMm: 312.8,
  /** The catch a year: recreational fish landed (MRIP), MRIP's weight of one kg (the measured ones weighed by the curve, a check), the commercial kg (DAR), and the whole. */
  recreationalFish: 64179,
  keptMeanKg: 0.8289,
  lengthMeanKg: 1.2477,
  commercialKg: 2487.2,
  catchKg: 55686,
} as const;
